module.exports = __webpack_public_path__ + "img/contact-hero-9324d17.jpg";